$(document).ready(function() {
    $('.engraving').removeClass('loading');
    let lastFocusedDiv = null;
    const maxLength = $('.engraving-form').attr('data-chars-numbers');

    function getCharCount(div) {
        const clonedDiv = $(div).clone();
        clonedDiv.find('span').replaceWith('X'); // Replace content with 'X' or any other symbol
        const textContent = clonedDiv.text();
        return textContent.length;
    }

    function updateCharCount(div) {
        let text = div.text().trim();
        let count = getCharCount(text);
        div.next('.char-count').text(`Character count: ${count}`);
    }
    
    function textInputListener() {
        $(this).find('br').remove();
        const $div = $(this);
        const currentLength = getCharCount($div);

        if (currentLength > maxLength) {
            // If text length exceeds maximum value, prevent input
            const text = $div.html();
            const tempDiv = $('<div>').html(text);

            // Remove extra characters while preserving HTML structure
            let charCount = 0;
            tempDiv.contents().each(function() {
                if (this.nodeType === Node.TEXT_NODE) {
                    const textNode = this;
                    const textLength = textNode.textContent.length;
                    if (charCount + textLength > maxLength) {
                        textNode.textContent = textNode.textContent.slice(0, maxLength - charCount);
                        charCount = maxLength;
                    } else {
                        charCount += textLength;
                    }
                } else if (this.nodeType === Node.ELEMENT_NODE) {
                    charCount += 1;
                }
            });

            $div.html(tempDiv.html());
            // Move cursor to end of text
            const range = document.createRange();
            const sel = window.getSelection();
            range.setStart($div[0], 1);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
            return
        }

        drawText();
        const item = $(this).closest('.engraving-form-lines-item-input-wrapper');
        const counter = item.find('.engraving-form-lines-item-count span');
        counter.text(currentLength);
    }

    function drawText() {
        const textLines = [
            $('#line1').html(),
            $('#line2').html(),
            $('#line3').html()
        ];

        textLines.forEach((line, index) => {
            if (line) {
                $(`#engraving-text${index + 1}`).removeClass('engraving-canvas-text-hidden');
                $(`#engraving-text${index + 1}`).html(line);
            } else {
                $(`#engraving-text${index + 1}`).addClass('engraving-canvas-text-hidden');
            }
        });
    }

    function changeFont() {
        const selectedFont = $('input[name="font"]:checked').val();

        if (selectedFont == 'Handwritten typography') {
            $('.engraving-canvas-text').removeClass('engraving-canvas-text-garamond');
        } else {
            $('.engraving-canvas-text').addClass('engraving-canvas-text-garamond');
        }
    }

    // Track the last active div
    $('.engraving-form-lines-item-input').on('focus', function() {
        lastFocusedDiv = $(this);
    });

    $('#addSun').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if  (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">S</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    $('#addMoon').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if  (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">M</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    $('#addStar').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">T</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    $('#addHeart').click(function() {
        const currentLength = getCharCount(lastFocusedDiv);
        if  (lastFocusedDiv && (currentLength < maxLength)) {
            lastFocusedDiv.append('<span contenteditable="false">H</span>');
            drawText();
            const item = lastFocusedDiv.closest('.engraving-form-lines-item-input-wrapper');
            const counter = item.find('.engraving-form-lines-item-count span').text(currentLength + 1);
        }
    });

    function replaceSpans(html) {
        // Handle empty or null HTML
        if (!html || html.trim() === '') {
            return '';
        }

        // Create temporary element for HTML processing
        var tempDiv = $('<div></div>').html(html);

        tempDiv.find('span').each(function() {
            const spanText = $(this).text().trim();
            if (spanText === 'S') {
                $(this).replaceWith('*sun*');
            } else if (spanText === 'M') {
                $(this).replaceWith('*moon*');
            } else if (spanText === 'T') {
                $(this).replaceWith('*star*');
            } else if (spanText === 'H') {
                $(this).replaceWith('*heart*');
            }
        });

        // Clean up any remaining HTML tags and return plain text
        const cleanText = tempDiv.text().trim();
        return cleanText;
    }

    function addTocart() {
        const form = $('.engraving-form');

        $('.engraving').addClass('loading');

        const productId = form.attr('data-product-id');
        const engravingId = form.attr('data-engraving-id');

        // Validate that we have the required IDs
        if (!productId || !engravingId) {
            console.error('Missing product ID or engraving ID');
            alert('Error: Product configuration is missing. Please contact support.');
            $('.engraving').removeClass('loading');
            return;
        }

        // Prepare engraving properties
        const engravingProperties = {
            'Engraving line 1': replaceSpans($('#line1').html()),
            'Engraving line 2': replaceSpans($('#line2').html()),
            'Engraving line 3': replaceSpans($('#line3').html()),
            'Engraving font': $('input[name="font"]:checked').val(),
        };

        // Add both products sequentially
        addProductsSequentially(productId, engravingId, engravingProperties);
    }

    async function addProductsSequentially(productId, engravingId, engravingProperties) {
        try {
            // First add the main product
            const productResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            });

            if (!productResponse.ok) {
                const productError = await productResponse.json();
                throw new Error(`Failed to add main product: ${productError.description || 'Unknown error'}`);
            }

            console.log('Main product added successfully');

            // Then add the engraving product with properties
            const engravingResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: engravingId,
                    quantity: 1,
                    properties: engravingProperties
                })
            });

            if (!engravingResponse.ok) {
                const engravingError = await engravingResponse.json();
                throw new Error(`Failed to add engraving: ${engravingError.description || 'Unknown error'}`);
            }

            console.log('Engraving added successfully');
            
            // Both products added successfully, redirect to cart
            window.location.replace("/cart");
            $('.engraving').removeClass('loading');

        } catch (error) {
            console.error('Error adding products to cart:', error);
            alert(`Error adding to cart: ${error.message}`);
            $('.engraving').removeClass('loading');
        }
    }
    
    
    $('.engraving-form-lines-item-input').on('input', textInputListener);

    $('input[name="font"]').change(changeFont);

    $('#submit-button').click(addTocart);

});